import {types} from './types';

const setGetListAdminAction = (payload) => {
  return {
    type: types.SET_LIST,
    payload,
  }
}

const setGetListHistoryAction = (payload) => {
  return {
    type: types.SET_HISTORY,
    payload,
  }
}

const setGetListEventsAction = (payload) => {
  return {
    type: types.SET_EVENT,
    payload,
  }
}

const setGetViewAdminAction = (payload) => {
  return {
    type: types.SET_VIEW,
    payload
  }
}

export {
  setGetListAdminAction,
  setGetListHistoryAction,
  setGetListEventsAction,
  setGetViewAdminAction
}